import './ShiftToolTip.scss';
import { Tooltip } from '@material-ui/core';
import { SwapHoriz } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { SegmentType } from '../../enums/index';
import { genShiftTooltipLabelAndTime } from '../../utilities/shiftFunctions';

/**
 * @param {{ id: any }} x
 * @param {number} i
 */
function getKey(x, i) {
    return `${x.id}-${i}`;
}
/**
 * @param {CommonClient2.ShiftTooltipProps} props
 * @returns
 */
const ShiftToolTip = ({ element, shiftInfos }) => { // TODO change element to children
    const { t } = useTranslation('common');

    return (
        <Tooltip
            arrow
            enterDelay={500}
            enterNextDelay={500}
            classes={{
                popper: 'ShiftTooltip',
            }}
            placement="top"
            title={(
                <div className="ShiftTooltipContent">
                    <div className="ShiftToolTipShiftSection">
                        <div className="ShiftTooltipShiftBlueBox">{t('shift')}</div>
                    {
                        shiftInfos.date ? (
                            <div className="ShiftTooltipShiftDate">{shiftInfos.date}</div>
                        ) : null
                    }
                    {genShiftTooltipLabelAndTime(shiftInfos)}
                </div>
                {
                    shiftInfos.segments.map((x, i) => (
                        <div
                            key={`ShiftToolTipSegmentsSection_${shiftInfos.id}_${x.id}`}
                            className="ShiftToolTipSegmentsSection"
                        >
                            <div className="ShiftTooltipSegmentDate">
                                <span className="ShiftTooltipSegmentIndex">{i + 1}</span>
                                <span className="ShiftTooltipSegmentTime">{x.timeString}</span>
                                {x.segmentType === SegmentType.TRANSFER_SEGMENT && <SwapHoriz />}
                                {x.segmentType === SegmentType.BREAK_SEGMENT && ` (${t('break')})`}
                            </div>
                            {
                                x.segmentType === SegmentType.REGULAR_SEGMENT && (
                                    <div className="ShiftTooltipSegmentLocation">{x.orgJobPath}</div>
                                )
                            }
                            {
                                x.segmentType === SegmentType.TRANSFER_SEGMENT && x.transferStrings?.map((value, index) => (
                                    <div
                                        className="ShiftTooltipSegmentLocation"
                                        key={getKey(x, index)}
                                    >
                                        {value}
                                    </div>
                                ))
                            }
                            {
                                x.costCenterDictionary && Object.entries(x.costCenterDictionary).filter(([, value]) => value != null && value !== '').length > 0 && (
                                    <div className="ShiftTooltipSegmentCostCenter-container">
                                        <div>{t('costCenters')}</div>
                                        {Object.entries(x.costCenterDictionary).filter(([, value]) => value != null && value !== '').map(([key, value]) => (<div key={key}>{key}: {value}</div>))}
                                    </div>
                                )
                            }
                            {
                                x.skillAndCertifProfileLabels && x.skillAndCertifProfileLabels.length > 0 && (
                                    <div className="ShiftTooltipSegmentScProfiles-container">
                                        <div>{t('skillAndCertificationProfiles')}</div>
                                        {x.skillAndCertifProfileLabels.map(x => (<div>{x}</div>))}
                                    </div>
                                )
                            }
                        </div>
                    ))
                }
            </div>
        )}
        >
            {
                element
            }
        </Tooltip>
    );
};

export default ShiftToolTip;
